import {
  ApiP1MetricsResponse,
  MetricTrend,
  P1Metrics,
} from "@/core/dashboard/entities/P1Metrics";
import { toColorIndicator } from "./colorIndicatorMapper";

/**
 * Normalizes the raw trend string to the domain enum.
 * Uses explicit branching to avoid dynamic object access patterns flagged by
 * detect-object-injection.
 */
function toTrend(raw: string | null | undefined): MetricTrend | null {
  switch ((raw ?? "").toUpperCase()) {
    case "UP":
      return "UP";
    case "DOWN":
      return "DOWN";
    case "STABLE":
      return "STABLE";
    default:
      return null;
  }
}

/**
 * Maps GET /api/v1/dashboard/commercial/p1/metrics to the P1Metrics domain model.
 * All field name translations live here.
 */
export default class P1MetricsMapper {
  static toDomain(api: ApiP1MetricsResponse): P1Metrics {
    return {
      onboardingVolume: {
        value: api.onboardingVolume?.value ?? null,
      },
      kycCompletionRate: {
        value: api.kycCompletionRate?.value ?? null,
        totalClients: api.kycCompletionRate?.totalClients ?? 0,
        completeClients: api.kycCompletionRate?.completeClients ?? 0,
      },
      timeToCollect: {
        averageDays: api.timeToCollect?.averageDays ?? null,
        totalCases: api.timeToCollect?.totalCases ?? 0,
        submittedCases: api.timeToCollect?.submittedCases ?? 0,
        inProgressCases: api.timeToCollect?.inProgressCases ?? 0,
        outlierCount: api.timeToCollect?.outlierCount ?? 0,
        previousMonthAverage: api.timeToCollect?.previousMonthAverage ?? null,
        trend: toTrend(api.timeToCollect?.trend),
      },
      conversionRate: {
        value: api.conversionRate?.value ?? null,
        totalProspects: api.conversionRate?.totalProspects ?? 0,
        convertedClients: api.conversionRate?.convertedClients ?? 0,
        pendingProspects: api.conversionRate?.pendingProspects ?? 0,
        colorIndicator: toColorIndicator(api.conversionRate?.colorIndicator),
      },
    };
  }
}
